import { AppError } from '@profile/src/redux/types';
export function formatErrorMessage(error) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Unknown error has occurred';

    default:
      return 'Something error happened try again later';
  }
}